// extracted by mini-css-extract-plugin
export default {"card":"yZ-z","carouselContainer":"zZ-z","carouselContent":"AZ-z"};